import { IAppState } from '../../redux';
import { EBusinessType } from '../../types/businessType';

export function filterReadyBusinessTypesSelector(state: IAppState): EBusinessType | undefined {
  return state.offer.readyBusinessType;
}
